// config
// dependencies
import { List, Map } from "immutable";
import { createSelector } from "reselect";

import Config from "./Config";

import { getJobTitleField, getRoleField } from "../../selectors/fields";
// selectors
import { getFullGroups } from "../../selectors/groups";
import { urlParams } from "../../selectors/navigation";

export const getPageUISelector = (state) => state.page.get(Config.pageName, Map());
export const getGroupId = (state) => urlParams(state).getIn(["groupId"]);
export const getActiveScreen = (state) => getPageUISelector(state).get("activeScreen", "MEMBERS");
export const getEditingGroupName = (state) => getPageUISelector(state).get("editingGroupName", "");
export const getUserIsAGroupAdmin = (state) => getPageUISelector(state).get("userIsAGroupAdmin", false);
export const employeesTableColumnsSelector = (state) => getPageUISelector(state).get("employeesColumns", List());

/*
    Gets a group from the navigation props
*/
export const getGroupObject = createSelector([getFullGroups, getGroupId], (groups, groupId) =>
	groups.get(groupId, Map())
);

/*
    get the columns from the UI and insert Job Title at position 1 and Role at
    position 2 (right of Job Title) when those fields exist on the company.
*/
export const getEmployeesTableColumns = createSelector(
	[getJobTitleField, getRoleField, employeesTableColumnsSelector],
	(jobTitleField, roleField, columns) => {
		let tableColums = columns;

		if (jobTitleField) {
			tableColums = tableColums.splice(1, 0, jobTitleField.set("id", "_jobTitle"));
		}

		if (roleField) {
			const insertIndex = jobTitleField ? 2 : 1;
			tableColums = tableColums.splice(insertIndex, 0, roleField.set("id", "_role"));
		}

		return tableColums;
	}
);

// gets the queue member list
export const getQueuedMemberList = (state) => getPageUISelector(state).get("memberQueue", List());

// get the permissions map
export const getPermissions = (state) => getPageUISelector(state).get("permissions", Map());
